import {useNavigate} from 'react-router-dom';
import noImge from '../../../assets/image/newShop/defaultImg.png';
import {timeAgoPersian} from '../../../utilities/helper/GetPersianDateTime';

const SuggestProductCard = ({item}: {item: IGetSuggestAdvertisement}) => {
  const navigate = useNavigate();

  return (
    <div
      className="w-[300px] shrink-0 rounded-xl shadow-md p-3 flex items-start gap-3 border h-full bg-white"
      onClick={() => navigate('/category-card-detail/fertilizer/' + item.id)}
    >
      <img
        src={(item?.main_image || item?.sub_brand_main_image?.image) ?? noImge}
        className="object-fill w-20 rounded-lg"
      />

      <div className="flex flex-col justify-between w-full h-full">
        <div>
          <span className="font-medium text-black line-clamp-1 text-md">
            {item?.title}
          </span>
          <div className="text-gray-700 flex items-center gap-[3px] mt-[2px]">
            <i className="text-lg icon-nameLocation" />
            <span className="text-sm">
              {item?.state?.name}، {item?.city.name}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-700">
            {timeAgoPersian(item?.created_at)}
          </span>
          {item?.ad_price && (
            <span className="font-medium text-black text-md">
              {item?.ad_price?.toLocaleString()}{' '}
              <span className="text-sm">تومان</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuggestProductCard;
